<template>
  <v-alert
    :value="error"
    type="error"
    text
  >
    {{ text }}

    <p
      v-for="(e) in validationErrors"
      :key="e"
    >
      {{ e }}
    </p>
  </v-alert>
</template>

<script>
export default {
    props: {
        error: {
          type: Object,
          default: () => null,
        },
    },
    computed: {
        validationErrors () {
          if (!this.error) return null

          const { data } = this.error;
          if (!data) return null

          const { validationErrors } = data;
          if (!validationErrors) return null

          return Object.values(validationErrors)
        },
        text () {
            if (!this.error) return null

            return this.error.message || this.error
        },
    }
}
</script>
